import React from "react"
import { useParams, useSearchParams } from "react-router-dom"
import { appStore } from "lib/state"
import { cn, queryTools } from "lib/utils"
import { StatementsList } from "."


export default function StatementsWrapper({ elemtype }:{ elemtype:string }){
  const { dspid } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams() 

  const { store, AppStore }:any = appStore()
  const { update } = AppStore

  const { data:_Dispute } = queryTools.resource.parseQueryForApi("dispute.findById", { id: dspid }, { enabled: !!dspid })

  if( !_Dispute ) return <></>
  return (
    <div className="w-full h-full *:text-neutral-200 pt-5">
      
      { searchParams.get("op") === "list" && (
        <StatementsList elemtype={elemtype} /> 
      )}

      { searchParams.get("op") === "add" && searchParams.get("stid") !== null && (
        <p>add</p>
      )}

      { searchParams.get("op") === "edit" && searchParams.get("stid") !== null && (
        <p>edit</p>
      )}
      


    </div>
  )
}
